module.exports = __webpack_public_path__ + "media/images/pie/pings2-88e2359561e1c19868fc05d2f244f6c4.png";